import { SYSTEM_ROLES } from "common/enum";

export const getUserRole = (v: string) => {
  const r = Object.keys(SYSTEM_ROLES).find(
    (role) => (SYSTEM_ROLES as any)[role] === v
  );
  return r?.substring(0, r.length - 5) || "";
};
